var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.039,
    height: 16.039,
    viewBox: "0 0 16.039 16.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close",
    "data-name": "Icon ionic-md-close",
    d: "M23.563,9.127l-1.6-1.6-6.416,6.416L9.127,7.523l-1.6,1.6,6.416,6.416L7.523,21.959l1.6,1.6,6.416-6.416,6.416,6.416,1.6-1.6-6.416-6.416Z",
    transform: "translate(-7.523 -7.523)",
    fill: "#4d6382"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ee964ef584a29645d24443cd3040aea3.svg";
export { ForwardRef as ReactComponent };